import React, { useState, useEffect, useCallback, useRef } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Draggable Scroll
import { useDraggable } from 'react-use-draggable-scroll';

// date-fns
import DateFnsUtils from '@date-io/date-fns';

// Formik
import { useFormik } from 'formik';

// Yup
import { object, string, array, number } from 'yup';

// Material
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import {
  MuiPickersUtilsProvider,
  TimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

// Material Icon
import CloseIcon from '@material-ui/icons/Close';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

// clsx
import clsx from 'clsx';

// Actions
import * as ModalFilterActions from 'store/ducks/modalFilter/actions';
import * as UsersActions from 'store/ducks/users/actions';
import { scheduleCreateRequest } from 'store/ducks/reports/actions';
import * as GroupingModalActions from 'store/ducks/groupingModal/actions';

// Types
import { ApplicationState } from 'store';
import { GroupingModalOptionsInterface } from 'store/ducks/groupingModal/types';

// Contants
import BALANCE from 'constants/balance';
import QRCODE_TYPES from 'constants/qrcodes';
import IMAGES from 'constants/images';
import REPORTS from 'constants/report';
import CONST_DATE_TYPE_SALES_REPORT from 'constants/dateTypeSalesReport';

// Components
import { GroupingModal, MainContent, BackAndForwardControl } from 'components';
import { ChartFilterModal } from '../../../../ChartFilterModal';

// Styles
import useStyles from './SubmissionSettingsAdd.styles';

interface ChipsInterface {
  filter: object;
}

interface setSubmissionDataInterface {
  setIsAddSubmissiion: (param: boolean) => void;
  reportType: string;
  secondReportType?: string;
  reportName: string;
  filterOptions?: string[];
  groupOptions?: GroupingModalOptionsInterface[];
  secondGroupOptions?: GroupingModalOptionsInterface[];
}

const SubmissionSettingsAdd: React.FC<setSubmissionDataInterface> = ({
  setIsAddSubmissiion,
  reportType,
  secondReportType,
  reportName,
  filterOptions,
  groupOptions,
  secondGroupOptions,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const parentRef: any = useRef();
  const { events } = useDraggable(parentRef);

  const [filters, setFilters] = useState<ChipsInterface[]>([]);
  const [frequency, setFrequency] = useState('');
  const [options, setOptions] = useState('repeat');
  const [hourOfFrequency, setHourOfFrequency] = useState(new Date());
  const [finishIn, setFinishIn] = useState('never');
  const [selectUser, setSelectUser] = useState<string[]>([]);
  const [filterUser, setFilterUser] = useState<string[]>([]);
  const [currentGoupOptions, setCurrentGoupOptions] = useState<
    GroupingModalOptionsInterface[]
  >();
  const [selectedReportType, setSelectedReportType] = useState<string>(
    REPORTS.REPORT_NAME.find(({ KEY }) => KEY === secondReportType)?.NAME || '',
  );

  const [selectedDate, setSelectedDate] = React.useState<Date | null>(
    new Date(),
  );
  const [state, setState] = useState({
    pdf: false,
    csv: false,
  });

  const [week, setWeek] = useState({
    MONDAY: false,
    TUESDAY: false,
    WEDNESDAY: false,
    THURSDAY: false,
    FRIDAY: false,
    SATURDAY: false,
    SUNDAY: false,
  });

  const { pdf, csv } = state;
  const selectReportType = [reportType, secondReportType];
  const activeFilterOptions = filterOptions?.filter(
    (opt) => opt !== 'DAY' && opt !== 'PERIOD',
  );

  const selectedItems = useSelector(
    (state: ApplicationState) => state.groupingModal.selectedItems,
  );

  const webUsersList = useSelector(
    (state: ApplicationState) => state.users.webUsersList || [],
  );

  const formik = useFormik({
    initialValues: {
      reportType,
      title: '',
      status: 1,
      supervisorIds: [],
      filters: {},
      groupings: [],
      frequencyType: 0,
      frequencyMonthday: '',
      frequencyQuantity: 0,
      frequencyMonth: '',
      frequencyHour: '',
      frequencyWeekday: [],
      repeatUntil: { type: 0, value: undefined } as { type: number; value: number | undefined },
      dataInterval: 0,
      formats: [],
    },
    validationSchema: object().shape({
      title: string().required('Campo nome obrigatório'),
      supervisorIds: array()
        .min(1, 'Você precisa adicionar pelo menos um destinatario')
        .required('Campo email obrigatório.')
        .nullable(),
      formats: array()
        .min(1, 'Você precisa adicionar pelo menos um destinatario')
        .required('Campo formatos obrigatório.')
        .nullable(),
      filters: object(),
    }),
    onSubmit: (values) => {
      dispatch(scheduleCreateRequest(values));
    },
  });

  const {
    values,
    handleSubmit,
    handleBlur,
    errors,
    touched,
    setFieldValue,
  } = formik;

  const handleChangeNewEmail = (value: string) => {
    if (webUsersList.length) {
      const filterArray = webUsersList
        .filter((user) => user.name.includes(value))
        .map((user) => user.name);
      setSelectUser(filterArray);
    }
  };

  const handleFillSubmissionDate = (key: string, value: any) => {
    setFieldValue(key, value);
  };

  const handleChangeCheckobx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      const dateString = date.toLocaleDateString('pt-BR');
      setSelectedDate(date);
      setFieldValue('frequencyMonthday', dateString.split('/')[0]);
      setFieldValue('frequencyMonth', Number(dateString.split('/')[1]));
    }
  };

  const handleAddUser = (value: string | null) => {
    if (value?.trim()) {
      const isIncluded = filterUser.some((item) => item === value.trim());
      if (!isIncluded) {
        const filterId = webUsersList.find((user) => user.name === value)?.id;
        setFilterUser([...filterUser, value]);
        handleFillSubmissionDate('supervisorIds', [
          ...values.supervisorIds,
          filterId,
        ]);
      }
    }
  };

  const handleRemoveUser = (user: string) => {
    const namesUpdate = filterUser.filter((name) => name !== user);

    const filterId = webUsersList.find((item) => item.name === user)?.id;
    const idsUpdate = values.supervisorIds.filter((id) => id !== filterId);
    setFilterUser(namesUpdate);
    handleFillSubmissionDate('supervisorIds', idsUpdate);
  };

  const handleFilters = useCallback((data: any) => {
    const {
      isStartedAt,
      startedAt,
      startDate,
      endDate,
      selectedProfiles,
      selectedPayments,
      selectedQRCodes,
      selectedLines,
      selectedDbds,
      selectedCars,
      selectedEmployees,
      selectedSellingPoint,
      creditType,
      selectedPaymentType,
      filenameSelected,
      selectedSeccionedLine,
      selectedDateType,
      selectedCollection,
      selectedSupervisors,
    } = data;


    const filters: ChipsInterface[] = [];

    if (isStartedAt) {
      filters.push({
        filter: {
          startDate: new Date(startedAt).setHours(0, 0, 0),
          endDate: new Date(startedAt).setHours(23, 59, 59),
        },
      });
    }

    if (!isStartedAt && startDate && endDate) {
      filters.push({
        filter: {
          startDate: new Date(startDate).getTime(),
          endDate: new Date(endDate).getTime(),
        },
      });
    }

    if (Array.isArray(selectedLines) && selectedLines.length > 0) {
      filters.push({
        filter: { lineId: selectedLines.map((e: any) => e.id) },
      });
    }
    if (Array.isArray(selectedProfiles) && selectedProfiles.length > 0) {
      filters.push({
        filter: { profileId: selectedProfiles.map((e: any) => e.id) },
      });
    }
    if (Array.isArray(selectedPayments) && selectedPayments.length > 0) {
      filters.push({
        filter: {
          usageType: selectedPayments.map(
            (e: any) => BALANCE.USAGE_TYPES.find(({ ID }) => ID === e.key)?.KEY,
          ),
        },
      });
    }
    if (Array.isArray(selectedQRCodes) && selectedQRCodes.length > 0) {
      filters.push({
        filter: {
          qrcodeType: selectedQRCodes.map(
            (e: any) =>
              QRCODE_TYPES.ENTRY.find((item: any) => item.VALUE === e.value)
                ?.KEY,
          ),
        },
      });
    }
    if (Array.isArray(selectedDbds) && selectedDbds.length > 0) {
      filters.push({
        filter: { dbdId: selectedDbds.map((e: any) => e.id) },
      });
    }
    if (Array.isArray(selectedCars) && selectedCars.length > 0) {
      filters.push({
        filter: { carId: selectedCars.map((e: any) => e.id) },
      });
    }
    if (Array.isArray(selectedEmployees) && selectedEmployees.length > 0) {
      filters.push({
        filter: { employeeId: selectedEmployees.map((e: any) => e.id) },
      });
    }
    if (selectedSellingPoint.length > 0) {
      filters.push({
        filter: {
          sellingPointId: selectedSellingPoint
            .map((point: any) => point.id)
            .join(),
        },
      });
    }
    if (Array.isArray(creditType) && creditType?.length > 0) {
      filters.push({
        filter: {
          transactionType: creditType.map((e: any) => e.key).join(),
        },
      });
    }
    if (Array.isArray(selectedPaymentType) && selectedPaymentType?.length > 0) {
      filters.push({
        filter: {
          paymentType: selectedPaymentType.map((e: any) => e.KEY).join(),
        },
      });
    }
    if (filenameSelected) {
      filters.push({
        filter: {
          filename: filenameSelected,
        },
      });
    }
    if (selectedSeccionedLine !== null) {
      filters.push({
        filter: { seccioned: Boolean(selectedSeccionedLine) },
      });
    }
    if (selectedDateType !== '') {
      filters.push({
        filter: {
          dateType: Object.values(CONST_DATE_TYPE_SALES_REPORT.TYPE).find(
            (s) => s.VALUE === selectedDateType,
          )?.VALUE,
        },
      });
    }
    if (selectedCollection !== null) {
      filters.push({
        filter: {
          chargeType: selectedCollection,
        },
      });
    }
    if (Array.isArray(selectedSupervisors) && selectedSupervisors.length > 0) {
      filters.push({
        filter: {
          supervisorId: selectedSupervisors.map((e: any) => e.id).join(),
        },
      });
    }
    setFilters(filters);
  }, []);

  useEffect(() => {
    if (filters.length) {
      let auxFilters: any = {};
      filters.forEach(({ filter }) => {
        auxFilters = Object.assign({}, auxFilters, filter);
      });
      handleFillSubmissionDate('filters', auxFilters);
    }
  }, [filters]);

  useEffect(() => {
    if (selectedItems.length) {
      const filterSelectedItems = selectedItems.map(({ key }) => key);
      handleFillSubmissionDate('groupings', filterSelectedItems);
    }
  }, [selectedItems]);

  useEffect(() => {
    const result = Object.entries(week)
      .filter(([key, value]) => value)
      .map(([key, value]) => key);
    handleFillSubmissionDate('frequencyWeekday', result?.[0] || '');
  }, [week]);

  useEffect(() => {
    setFieldValue('frequencyMonthday', '');
    setFieldValue('frequencyMonth', '');
    setFieldValue('frequencyWeekday', '');
  }, [values.frequencyType]);

  useEffect(() => {
    const aux: string[] = [];
    if (state.pdf) aux.push('PDF');
    if (state.csv) aux.push('CSV');
    setFieldValue('formats', aux);
  }, [state]);

  useEffect(() => {
    setFieldValue(
      'frequencyHour',
      `${new Date(hourOfFrequency).getHours()}:${new Date(
        hourOfFrequency,
      ).getMinutes()}`,
    );
  }, [hourOfFrequency]);

  useEffect(() => {
    if (values.frequencyType === 0) {
      const result = Number(frequency) * 86400000;
      setFieldValue('dataInterval', result);
    }

    if (values.frequencyType === 1) {
      const result = Number(frequency) * 86400000 * 7;
      setFieldValue('dataInterval', result);
    }
    if (values.frequencyType === 2) {
      const result = Number(frequency) * 86400000 * 30;
      setFieldValue('dataInterval', result);
    }
    if (values.frequencyType === 3) {
      const result = Number(frequency) * 86400000 * 365;
      setFieldValue('dataInterval', result);
    }
  }, [frequency]);


  useEffect(() => {
    if (finishIn === 'in') {
      handleFillSubmissionDate('repeatUntil', {
        type: 2,
        value: new Date().getTime(),
      });
    }
  }, [finishIn]);
  useEffect(() => {
    if (selectedReportType) {
      setFieldValue(
        'reportType',
        REPORTS.REPORT_NAME.find(({ NAME }) => NAME === selectedReportType)
          ?.KEY,
      );
    }
    if (
      groupOptions &&
      (REPORTS.REPORT_NAME.find(({ NAME }) => NAME === selectedReportType)
        ?.KEY === reportType ||
        REPORTS.REPORT_NAME.find(({ NAME }) => NAME === selectedReportType)
          ?.KEY === secondReportType)
    ) {
      setCurrentGoupOptions(groupOptions);
    }

    if (
      secondGroupOptions &&
      REPORTS.REPORT_NAME.find(({ NAME }) => NAME === selectedReportType)
        ?.KEY === secondReportType
    ) {
      setCurrentGoupOptions(secondGroupOptions);
    }
  }, [selectedReportType]);

  useEffect(() => {
    dispatch(
      UsersActions.listWebUsersRequest({
        body: { _includes: 'operators', _limit: 9999 },
      }),
    );
  }, []);

  useEffect(() => {
    dispatch(
      GroupingModalActions.setSelectedItems({
        selectedItems: [],
      }),
    );
  }, []);

  return (
    <div className={classes.root}>
      <MainContent className={classes.paperRoot}>
        <BackAndForwardControl
          handleButton={() => setIsAddSubmissiion(false)}
        />
        <Grid
          container
          justifyContent='space-between'
          className={classes.gridContainer}>
          <Grid item>
            <Typography
              variant='h4'
              color='inherit'
              data-testid='relatorio_label'>
              {reportName}
            </Typography>
          </Grid>
        </Grid>
        <form>
          <Grid className={classes.content}>
            <Typography color='primary' className={classes.label}>
              Titulo do Lote
            </Typography>
            <Box className={classes.contentTitleLote}>
              <TextField
                name='modules'
                value={values.title}
                margin='normal'
                variant='outlined'
                helperText={errors.title && touched.title && errors.title}
                onBlur={handleBlur}
                onChange={(e) =>
                  handleFillSubmissionDate('title', e.target.value)
                }
              />
            </Box>
            {secondReportType && (
              <TextField
                id='HeadContentSelectItem'
                select
                name='reportType'
                label='Relatório'
                variant='filled'
                value={selectedReportType}
                onChange={(e) => setSelectedReportType(e.target.value)}>
                {selectReportType.map((item) => (
                  <MenuItem
                    key={
                      REPORTS.REPORT_NAME.find(({ KEY }) => KEY === item)?.NAME
                    }
                    value={
                      REPORTS.REPORT_NAME.find(({ KEY }) => KEY === item)?.NAME
                    }>
                    {REPORTS.REPORT_NAME.find(({ KEY }) => KEY === item)?.NAME}
                  </MenuItem>
                ))}
              </TextField>
            )}
            <Divider variant='fullWidth' className={classes.firstDivider} />
            <Typography className={classes.title}>Destinatários</Typography>
            <Typography color='primary' className={classes.label}>
              Enviar para
            </Typography>
            <Grid
              className={classes.contentArrayRecipient}
              {...events}
              ref={parentRef}>
              <Grid item className={classes.autoComplete}>
                <Autocomplete
                  id='autocomplete-name'
                  autoComplete
                  options={selectUser}
                  includeInputInList
                  filterSelectedOptions
                  filterOptions={(x) => x}
                  onChange={(e: object, value: string | null) =>
                    handleAddUser(value)
                  }
                  onInputChange={(event, newInputValue) => {
                    handleChangeNewEmail(newInputValue);
                  }}
                  getOptionLabel={(option: any) =>
                    typeof option === 'string' ? option : option.display_name
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      className={classes.searchInput}
                      fullWidth
                      margin='normal'
                      variant='outlined'
                      helperText={
                        errors.supervisorIds &&
                        touched.supervisorIds &&
                        errors.supervisorIds
                      }
                      onBlur={handleBlur}
                    />
                  )}
                />
              </Grid>
              {filterUser.length < 6 && (
                <Box display='flex' alignItems='center' marginBottom='8px'>
                  {filterUser.map((item: string, i: number) => (
                    <Box className={classes.contentRecipient}>
                      <Box className={classes.contentImage}> </Box>
                      <Typography className={classes.recipient}>
                        {item}
                      </Typography>{' '}
                      <IconButton onClick={() => handleRemoveUser(item)}>
                        <CloseIcon style={{ fontSize: 16 }} />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              )}

              {filterUser.length > 5 && (
                <>
                  <Box display='flex' alignItems='center'>
                    {filterUser.map((item: string, i: number) => {
                      if (i % 2 === 0) {
                        return (
                          <Box className={classes.contentRecipient}>
                            <Box className={classes.contentImage}> </Box>
                            <Typography className={classes.recipient}>
                              {item}
                            </Typography>{' '}
                            <IconButton onClick={() => handleRemoveUser(item)}>
                              <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                          </Box>
                        );
                      }
                    })}
                  </Box>
                  <Box display='flex' alignItems='center'>
                    {filterUser.map((item: string, i: number) => {
                      if (i % 2 !== 0) {
                        return (
                          <Box className={classes.contentRecipient}>
                            <Box className={classes.contentImage}> </Box>
                            <Typography className={classes.recipient}>
                              {item}
                            </Typography>{' '}
                            <IconButton onClick={() => handleRemoveUser(item)}>
                              <CloseIcon style={{ fontSize: 16 }} />
                            </IconButton>
                          </Box>
                        );
                      }
                    })}
                  </Box>
                </>
              )}
            </Grid>
            <Divider variant='fullWidth' />
            {(activeFilterOptions || currentGoupOptions) && (
              <Grid item>
                <Typography className={classes.title}>
                  Filtros e Agrupamentos
                </Typography>

                <Grid
                  className={classes.contentFilters}
                  container
                  direction='column'>
                  {activeFilterOptions && (
                    <Grid item className={classes.scopeFilter}>
                      <Grid container>
                        <Tooltip
                          className={classes.filtersAgrupmentsReports}
                          title='Abre modal de filtros'
                          placement='top'
                          arrow>
                          <Typography
                            component='span'
                            onClick={() =>
                              dispatch(
                                ModalFilterActions.setOpenModal({
                                  openModal: true,
                                }),
                              )
                            }>
                            <Box
                              minWidth='64px'
                              display='flex'
                              alignItems='center'
                              justifyContent='space-between'>
                              <img
                                src={IMAGES.REPORTS_ICONS.FILTERS}
                                alt=' filters'
                              />
                              <Typography>Filtros</Typography>
                            </Box>
                            {Object.values(values.filters).length > 0 ? (
                              <Box className={classes.badge}>
                                {Object.values(values.filters).length}
                              </Box>
                            ) : null}
                          </Typography>
                        </Tooltip>
                      </Grid>
                      <Grid item>
                        <ChartFilterModal
                          handleSubmit={handleFilters}
                          hideIcon
                          filterOptions={activeFilterOptions}
                        />
                      </Grid>
                    </Grid>
                  )}
                  {currentGoupOptions && (
                    <Grid item className={classes.scopeFilter}>
                      <GroupingModal
                        filtersAgrupmentsReports={
                          classes.filtersAgrupmentsReports
                        }
                        badge={classes.badge}
                        scheduleSubmissionDate={values}
                        groupOptions={currentGoupOptions}
                      />
                    </Grid>
                  )}
                </Grid>
                <Divider variant='fullWidth' />
              </Grid>
            )}

            <FormControl className={classes.formControl}>
              <Grid item>
                <Typography className={classes.title}>Frequência</Typography>
                <RadioGroup
                  className={classes.radioGroup}
                  row
                  aria-labelledby='demo-form-control-label-placement'
                  defaultValue='repeat'
                  onChange={(e) => setOptions(e.target.value)}
                  name='position'>
                  <Grid>
                    <Box
                      className={classes.contentFormLabel}
                      display='flex'
                      alignItems='center'>
                      <FormControlLabel
                        value='repeat'
                        disabled={false}
                        control={
                          <Radio
                            checkedIcon={
                              <span
                                className={clsx(
                                  classes.icon,
                                  classes.checkedIcon,
                                )}
                              />
                            }
                            icon={<span className={classes.icon} />}
                          />
                        }
                        label='Repetir envio com determinada frequência'
                      />
                    </Box>
                    <Box
                      display='flex'
                      alignItems='center'
                      paddingLeft='6px'
                      marginTop='-12px'>
                      <Box display='flex' alignItems='center'>
                        <Box className={classes.onarmentDiv} />
                        <Typography>Repetir envio a cada</Typography>
                      </Box>

                      <Box className={classes.contentInput}>
                        <Box display='flex' alignItems='center'>
                          <TextField
                            className={classes.input}
                            id='HeadContentSelectItem'
                            disabled={options !== 'repeat'}
                            name='modules'
                            type='number'
                            value={values.frequencyQuantity}
                            margin='normal'
                            variant='outlined'
                            onChange={(e) =>
                              handleFillSubmissionDate(
                                'frequencyQuantity',
                                e.target.value,
                              )
                            }
                          />
                          <Divider
                            className={classes.dividerVertical}
                            orientation='vertical'
                            flexItem
                          />
                        </Box>

                        <TextField
                          className={classes.selectInput}
                          id='HeadContentSelectItem'
                          disabled={options !== 'repeat'}
                          select
                          name='modules'
                          variant='standard'
                          value={
                            REPORTS.FREQUENCY_TYPE_SELECT.find(
                              ({ KEY }) => KEY === values.frequencyType,
                            )?.VALUE
                          }
                          onChange={(e) => {
                            handleFillSubmissionDate(
                              'frequencyType',
                              REPORTS.FREQUENCY_TYPE_SELECT.find(
                                ({ VALUE }) => VALUE === e.target.value,
                              )?.KEY,
                            );
                            setWeek({
                              MONDAY: false,
                              TUESDAY: false,
                              WEDNESDAY: false,
                              THURSDAY: false,
                              FRIDAY: false,
                              SATURDAY: false,
                              SUNDAY: false,
                            });
                          }}
                          InputProps={{
                            disableUnderline: true,
                          }}>
                          {REPORTS.FREQUENCY_TYPE_SELECT.map(({ VALUE }) => (
                            <MenuItem key={VALUE} value={VALUE}>
                              {VALUE}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Box>
                    </Box>
                  </Grid>
                </RadioGroup>
              </Grid>
              <Grid item>
                <Typography className={classes.title}>Repetir</Typography>

                <Box display='flex' alignItems='center'>
                  {values.frequencyType === 1 && (
                    <Box display='flex' alignItems='center' paddingLeft='8px'>
                      <Box
                        className={
                          week.SUNDAY
                            ? classes.boxChecked
                            : classes.boxNoChecked
                        }>
                        <Checkbox
                          disabled={options !== 'repeat'}
                          icon={
                            <Typography className={classes.textIconNoChecked}>
                              Dom
                            </Typography>
                          }
                          checkedIcon={
                            <Typography className={classes.textIconChecked}>
                              Dom
                            </Typography>
                          }
                          onChange={() =>
                            setWeek((s) =>
                              Object.assign({}, s, { SUNDAY: !week.SUNDAY }),
                            )
                          }
                        />
                      </Box>
                      <Box
                        className={
                          week.MONDAY
                            ? classes.boxChecked
                            : classes.boxNoChecked
                        }>
                        <Checkbox
                          disabled={options !== 'repeat'}
                          icon={
                            <Typography className={classes.textIconNoChecked}>
                              Seg
                            </Typography>
                          }
                          checkedIcon={
                            <Typography className={classes.textIconChecked}>
                              Seg
                            </Typography>
                          }
                          onChange={() =>
                            setWeek((s) =>
                              Object.assign({}, s, { MONDAY: !week.MONDAY }),
                            )
                          }
                        />
                      </Box>
                      <Box
                        className={
                          week.TUESDAY
                            ? classes.boxChecked
                            : classes.boxNoChecked
                        }>
                        <Checkbox
                          disabled={options !== 'repeat'}
                          icon={
                            <Typography className={classes.textIconNoChecked}>
                              Ter
                            </Typography>
                          }
                          checkedIcon={
                            <Typography className={classes.textIconChecked}>
                              Ter
                            </Typography>
                          }
                          onChange={() =>
                            setWeek((s) =>
                              Object.assign({}, s, { TUESDAY: !week.TUESDAY }),
                            )
                          }
                        />
                      </Box>
                      <Box
                        className={
                          week.WEDNESDAY
                            ? classes.boxChecked
                            : classes.boxNoChecked
                        }>
                        <Checkbox
                          disabled={options !== 'repeat'}
                          icon={
                            <Typography className={classes.textIconNoChecked}>
                              Qua
                            </Typography>
                          }
                          checkedIcon={
                            <Typography className={classes.textIconChecked}>
                              Qua
                            </Typography>
                          }
                          onChange={() =>
                            setWeek((s) =>
                              Object.assign({}, s, {
                                WEDNESDAY: !week.WEDNESDAY,
                              }),
                            )
                          }
                        />
                      </Box>
                      <Box
                        className={
                          week.THURSDAY
                            ? classes.boxChecked
                            : classes.boxNoChecked
                        }>
                        <Checkbox
                          disabled={options !== 'repeat'}
                          icon={
                            <Typography className={classes.textIconNoChecked}>
                              Qui
                            </Typography>
                          }
                          checkedIcon={
                            <Typography className={classes.textIconChecked}>
                              Qui
                            </Typography>
                          }
                          onChange={() =>
                            setWeek((s) =>
                              Object.assign({}, s, {
                                THURSDAY: !week.THURSDAY,
                              }),
                            )
                          }
                        />
                      </Box>
                      <Box
                        className={
                          week.FRIDAY
                            ? classes.boxChecked
                            : classes.boxNoChecked
                        }>
                        <Checkbox
                          disabled={options !== 'repeat'}
                          icon={
                            <Typography className={classes.textIconNoChecked}>
                              Sex
                            </Typography>
                          }
                          checkedIcon={
                            <Typography className={classes.textIconChecked}>
                              Sex
                            </Typography>
                          }
                          onChange={() =>
                            setWeek((s) =>
                              Object.assign({}, s, { FRIDAY: !week.FRIDAY }),
                            )
                          }
                        />
                      </Box>
                      <Box
                        className={
                          week.SATURDAY
                            ? classes.boxChecked
                            : classes.boxNoChecked
                        }>
                        <Checkbox
                          disabled={options !== 'repeat'}
                          icon={
                            <Typography className={classes.textIconNoChecked}>
                              Sáb
                            </Typography>
                          }
                          checkedIcon={
                            <Typography className={classes.textIconChecked}>
                              Sáb
                            </Typography>
                          }
                          onChange={() =>
                            setWeek((s) =>
                              Object.assign({}, s, {
                                SATURDAY: !week.SATURDAY,
                              }),
                            )
                          }
                        />
                      </Box>
                    </Box>
                  )}
                  {values.frequencyType === 2 && (
                    <Box display='flex' alignItems='center' paddingLeft='8px'>
                      <Box
                        display='flex'
                        alignItems='center'
                        paddingRight='8px'
                        paddingLeft='8px'>
                        <Typography>Enviar sempre em:</Typography>
                      </Box>

                      <Box className={classes.contentInputOcorrency}>
                        <TextField
                          className={classes.input}
                          id='HeadContentSelectItem'
                          disabled={options !== 'repeat'}
                          name='modules'
                          type='number'
                          value={values.frequencyMonthday}
                          margin='normal'
                          variant='outlined'
                          onChange={(e) =>
                            handleFillSubmissionDate(
                              'frequencyMonthday',
                              e.target.value,
                            )
                          }
                        />
                      </Box>
                      <Typography> de cada mês, às</Typography>
                    </Box>
                  )}
                  {values.frequencyType === 3 && (
                    <Box display='flex' alignItems='center' paddingLeft='8px'>
                      <Box
                        display='flex'
                        alignItems='center'
                        paddingRight='8px'
                        paddingLeft='8px'>
                        <Typography>Enviar sempre em:</Typography>
                      </Box>
                      <Box className={classes.contentInputDate}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            disabled={options !== 'repeat'}
                            format='dd/MM/yyyy'
                            id='date-picker-inline'
                            value={selectedDate}
                            onChange={handleDateChange}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </Box>
                      <Typography>às</Typography>
                    </Box>
                  )}
                  <Box className={classes.contentInputHour}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <TimePicker
                        disabled={options !== 'repeat'}
                        ampm={false}
                        className={classes.input}
                        inputVariant='outlined'
                        value={hourOfFrequency}
                        onChange={(time: any) => setHourOfFrequency(time)}
                      />
                    </MuiPickersUtilsProvider>
                    <AccessTimeIcon style={{ color: '#AAB8C2' }} />
                  </Box>
                </Box>
              </Grid>
              <Box display='grid' marginTop='12px'>
                <Typography className={classes.title}>Termina em:</Typography>
                <RadioGroup
                  className={classes.radioGroup}
                  row
                  aria-labelledby='demo-form-control-label-placement'
                  value={finishIn}
                  onChange={(e) => {
                    if (e.target.value === 'never') {
                      handleFillSubmissionDate('repeatUntil', { type: 0, value: undefined });
                    }
                    setFinishIn(e.target.value);
                  }}
                  name='position'>
                  <Box
                    className={classes.contentFormLabel}
                    display='flex'
                    alignItems='center'>
                    <FormControlLabel
                      value='never'
                      disabled={false}
                      control={
                        <Radio
                          checkedIcon={
                            <span
                              className={clsx(
                                classes.icon,
                                classes.checkedIcon,
                              )}
                            />
                          }
                          icon={<span className={classes.icon} />}
                        />
                      }
                      label='Nunca'
                    />
                  </Box>
                  <Box
                    className={classes.contentFormLabel}
                    display='flex'
                    alignItems='center'>
                    <FormControlLabel
                      value='in'
                      disabled={false}
                      control={
                        <Radio
                          checkedIcon={
                            <span
                              className={clsx(
                                classes.icon,
                                classes.checkedIcon,
                              )}
                            />
                          }
                          icon={<span className={classes.icon} />}
                        />
                      }
                      label='Em'
                    />
                    <Box className={classes.contentInputDate}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disabled={finishIn !== 'in'}
                          format='dd/MM/yyyy'
                          id='date-picker-inline'
                          value={
                            values.repeatUntil?.value && typeof values.repeatUntil?.value === 'number'
                              ? new Date(values.repeatUntil.value)
                              : null
                          }
                          onChange={(date) =>
                            handleFillSubmissionDate('repeatUntil', {
                              type: 2,
                              value: date?.getTime(),
                            })
                          }
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </Box>
                  </Box>

                </RadioGroup>
              </Box>
              <Divider variant='fullWidth' />
              <Grid item>
                <Typography className={classes.title}>
                  Coleta de Dados{' '}
                </Typography>
                <Box
                  display='flex'
                  alignItems='center'
                  paddingLeft='6px'
                  marginTop='12px'
                  marginBottom='40px'>
                  <Typography>
                    Intervalo de tempo do relatório
                  </Typography>
                  <Box className={classes.contentInput}>
                    <Box display='flex' alignItems='center'>
                      <TextField
                        className={classes.input}
                        id='HeadContentSelectItem'
                        disabled={options !== 'repeat'}
                        type='number'
                        value={frequency}
                        margin='normal'
                        variant='outlined'
                        onChange={(e) => setFrequency(e.target.value)}
                      />
                      <Divider
                        className={classes.dividerVertical}
                        orientation='vertical'
                        flexItem
                      />
                    </Box>

                    <TextField
                      className={classes.selectInput}
                      id='HeadContentSelectItem'
                      disabled={options !== 'repeat'}
                      select
                      name='modules'
                      variant='standard'
                      value={
                        REPORTS.FREQUENCY_TYPE_SELECT.find(
                          ({ KEY }) => KEY === values.frequencyType,
                        )?.VALUE
                      }
                      onChange={(e) => {
                        handleFillSubmissionDate(
                          'frequencyType',
                          REPORTS.FREQUENCY_TYPE_SELECT.find(
                            ({ VALUE }) => VALUE === e.target.value,
                          )?.KEY,
                        );

                        setWeek({
                          MONDAY: false,
                          TUESDAY: false,
                          WEDNESDAY: false,
                          THURSDAY: false,
                          FRIDAY: false,
                          SATURDAY: false,
                          SUNDAY: false,
                        });
                      }}
                      InputProps={{
                        disableUnderline: true,
                      }}>
                      {REPORTS.FREQUENCY_TYPE_SELECT.map(({ VALUE }) => (
                        <MenuItem key={VALUE} value={VALUE}>
                          {VALUE}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Box>
                </Box>
              </Grid>
              <Divider variant='fullWidth' />
              <Grid item>
                <Typography className={classes.title}>
                  Formato dos Relatórios{' '}
                </Typography>
                <Typography>
                  Os relatórios serão enviados por e-mail nos seguintes formatos
                  para cada destinatário:
                </Typography>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        style={{ color: '##249eb2' }}
                        checked={pdf}
                        onChange={handleChangeCheckobx}
                        name='pdf'
                      />
                    }
                    label='PDF'
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        style={{ color: '##249eb2' }}
                        checked={csv}
                        onChange={handleChangeCheckobx}
                        name='csv'
                      />
                    }
                    label='CSV'
                  />
                </FormGroup>
              </Grid>
            </FormControl>
          </Grid>
        </form>
        <Grid container justifyContent='flex-start' className={classes.buttonContainer}>
          <Button
            className={classes.addButton}
            onClick={() => handleSubmit()}
            type='submit'>
            <Typography style={{ marginRight: 8, fontSize: 20 }} />{' '}
            <Typography style={{ fontSize: 12 }}>Programar Envio</Typography>
          </Button>
        </Grid>
      </MainContent>
    </div>
  );
};

export { SubmissionSettingsAdd };
export default SubmissionSettingsAdd;
